'use client';

import Link from 'next/link';

import { MAIL_CONFIG_BY_DOMAIN_AND_LOCALE } from '../constants';
import { IconsBlock } from './IconsBlock';
import { PhoneNumberBlock } from './PhoneNumberBlock';
import { ContactsCommonProps } from './types';

import { HOTLINE_PHONE } from '@/shared/constants/hotlinePhone';
import { Locale, TranslatedComponent } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

export const ContactsInner = ({
  translations,
  clientHost,
  locale,
}: TranslatedComponent & ContactsCommonProps & { locale: Locale }) => {
  const domain = getDomainKey(clientHost);
  const emailByDomainAndLocale =
    MAIL_CONFIG_BY_DOMAIN_AND_LOCALE[domain][locale];
  const phoneNumberByDomainAndLocale = HOTLINE_PHONE[domain][locale];

  return (
    <section
      id="contacts"
      className="bg-surface-base-secondary mt-7 flex min-h-[148px] flex-wrap items-center justify-between rounded-[28px] px-10 py-10 max-sm:mt-8 max-sm:h-auto max-sm:flex-col max-sm:items-start max-sm:rounded-none max-sm:bg-transparent max-sm:px-0 max-sm:pt-0 max-sm:pb-0 sm:gap-2"
    >
      {/** Контакты локальные и соцсети*/}
      <div className="flex flex-col gap-1">
        <div className="flex gap-2 text-white/20 opacity-65">
          <IconsBlock clientHost={clientHost} />
        </div>
        <PhoneNumberBlock clientHost={clientHost} locale={locale} />
      </div>

      {/** Телефон горячей линии */}
      {phoneNumberByDomainAndLocale ? (
        <div className="flex flex-col max-sm:mt-6">
          <span className="text-text-base-secondary mb-3 text-[16px] leading-[24px] max-sm:mb-1">
            {translations.contactsPhoneText}
          </span>
          <Link
            href={`tel:${phoneNumberByDomainAndLocale.href}`}
            className="text-[20px] leading-[32px]"
            aria-label={phoneNumberByDomainAndLocale.label}
          >
            {phoneNumberByDomainAndLocale.label}
          </Link>
        </div>
      ) : null}

      {/** Контакты на карте */}
      <div className="flex flex-col max-sm:mt-6">
        <Link
          href={`${translations.contactsOfficeMapLink}`}
          aria-label={translations.contactsOfficeMapLink}
          className="text-text-base-secondary mb-3 text-[16px] leading-[24px] max-sm:mb-1"
          target="_blank"
        >
          {translations.contactsOfficeMapText}
        </Link>

        {emailByDomainAndLocale ? (
          <Link
            href={`mailto:${emailByDomainAndLocale}`}
            className="text-[20px] leading-[32px]"
            aria-label={emailByDomainAndLocale}
          >
            {emailByDomainAndLocale}
          </Link>
        ) : null}
      </div>
    </section>
  );
};
